import classNames from "classnames/bind";
import styles from './HistoryDetect.module.css';
import { useCallback, useContext, useEffect, useState } from "react";
import { notification } from "../../../../services/api/Notification";
import { LisencePlateManagerContext } from "../../../../contexts";
import { Loading, Pagination, Table, Toast } from "../../../../components";
import { formatDateToTime } from "../../../../utils";

const cx = classNames.bind(styles);

function HistoryDetect() {
  const {  cameraCode, nameService } = useContext(LisencePlateManagerContext)
  const [listNotification, setListNotification] = useState();
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const getListNotification = useCallback(async () => {
    let param = {
      page: currentPage,
      size: 10,
      type: 'AI',
      ai_service_code: '20230222000000000006',
      camera_code: cameraCode
    }
    setIsLoading(true)
    try {
      const res = await notification.get(param);
      const total = Math.ceil(res.count / 10);
      setPages(total);
      setIsLoading(false);
      return res?.data;
    } catch (error) {
      setIsLoading(false);
      Toast.open('Không thể tải thông báo')
      return null
    }
  }, [currentPage, nameService, cameraCode])

  useEffect(() => {
    const getData = async () => {
      const data = await getListNotification()
      setListNotification(data)
    }
    getData()
  }, [getListNotification])

  const dataSource = listNotification?.map((item, index) => {
    return {
      stt: index + 1,
      name: item.NAME,
      description: item.DETAIL,
      time: `${item.TIME ? formatDateToTime(item?.TIME) : ''}`,
      type: item.NAME.toLowerCase(),
      user: item.RECEIVER,
    };
  });

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: 'Thông báo',
      key: "name",
    },
    {
      label: 'Nội dung',
      key: "description",
    },
    {
      label: 'Thời gian',
      key: "time",
    },
    {
      label: 'Loại thông báo',
      key: "type",
    },
    {
      label: 'Người nhận',
      key: "user",
    },
  ];

  const handleChosePage = (data) => {
    setCurrentPage(data)
  }
  const handleNext = () => {
    setCurrentPage(currentPage + 1)
  }
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1)
  }

  useEffect(() => {
    if (cameraCode) {
      handleChosePage(1)
    }
  }, [cameraCode])
  return (
    <div className={cx('wrapper')}>
      {isLoading ? (
        <div className={cx('loading')}>
          <Loading />
        </div>
      ) : (
        <>
          {
            cameraCode ? (
              <>
                <div className={cx('content-data')}>
                  <div className={cx('table-contain')}>
                    <Table colum={columns} data={dataSource} />
                  </div>
                  {listNotification && listNotification.length > 0 && (
                    <div className={cx('pagination')}>
                      <Pagination pages={pages} currentPage={currentPage} onClick={handleChosePage} onNext={handleNext} onPrevious={handlePrevious} />
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className={cx("empty")}>
                <p>Vui lòng lựa chọn camera để xem thông báo nhận dạng biển số xe!</p>
              </div>
            )
          }
        </>
      )}
    </div>
  )
}

export default HistoryDetect;